module.exports = __webpack_public_path__ + "static/media/1.945f7967.png";